export const DEFAULT_LABELS = {
	launchYear: 'Launch year',
	width: 'Width',
	height: 'Height',
	depth: 'Depth',
	weight: 'Weight'
};
